import { createContext, useContext } from 'react';
import { ShipmentItem } from '@/features/ShipmentView/types';

export const useShipmentViewProvider = ({ shipmentItem }: { shipmentItem: ShipmentItem }) => {
  const pastFilingWindow = (() => {
    if (!shipmentItem?.claimFilingWindowCloses) return false;
    const filingWindowCloseDate = new Date(shipmentItem.claimFilingWindowCloses);
    return filingWindowCloseDate.valueOf() < Date.now();
  })();

  const isClaimable = !!shipmentItem?.claimable && !pastFilingWindow;

  return {
    shipmentItem,
    isClaimable,
  };
};

type ShipmentViewContextType = ReturnType<typeof useShipmentViewProvider>;

export const ShipmentViewContext = createContext<ShipmentViewContextType>(
  {} as ShipmentViewContextType
);

export const useShipmentViewContext = () => {
  return useContext(ShipmentViewContext);
};
